import { Avatar } from '@mantine/core';

import { containerStyle } from './styles.css';

export function ContractedButton(props: {
  toggleDropdown: () => void;
  avatarUrl?: string;
  initials: string;
}) {
  return (
    <button className={containerStyle} onClick={props.toggleDropdown}>
      <Avatar src={props.avatarUrl} alt="workspace" color="red" radius="md" size="sm">
        {props.initials}
      </Avatar>
    </button>
  );
}
